import React, { useEffect, useState } from 'react';

import { CircularProgress } from "@mui/material";
import { Box, Typography, Stack } from "../../../imports/muiImport";
import MobileSectionTitle from './MobileSectionTitle';
import { NavLink, titleToUrl } from '../../../imports/generalImport';


const MaxDiscountCard = (props) => {
    const { image, altText, discount, data } = props;
    const redirectLink = `/card-details/${data?.id}/${titleToUrl(data?.title)}`;

    return (
        <NavLink
            to={redirectLink}
            style={{
                textDecoration: "none",
            }}
        >
            <Box component={"div"}
                sx={{
                    // display: "grid",
                    // gridTemplateRows: "80% 20%", // No commas

                    width: "100%",
                    // height: "100%",
                    height: "auto",
                    borderRadius: 2,

                    // border: "2px solid red",  

                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        // height: 110,
                        height: "100%",
                        // background: `linear-gradient(0deg,rgba(${darkImageRGBACode}) 0%, rgba(${lightImageRGBACode}) 100%)`,


                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',


                        position: 'relative',
                        overflow: 'hidden',
                    }}
                >
                    {/* Logo Image */}
                    <Box
                        component="img"
                        src={image}
                        alt={altText}
                        sx={{ width: "100%", height: "auto" }}
                    />

                </Box>
                {/* Bottom Text */}
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: {
                            xs: -1,
                            sm: 10
                        },
                        width: '100%',
                        textAlign: 'center',
                        // mt:1
                        // background: `linear-gradient(0deg,rgba(${darkTextRGBACode}) 0%, rgba(${lightTextRGBACode}) 100%)`,
                        // py: 0.2,
                    }}
                >
                    <Typography variant="subtitle1" sx={{ fontSize: "1rem", color: '#fff', fontWeight: 500 }}>
                        Save {discount}%
                    </Typography>
                </Box>
            </Box>
        </NavLink>
    );
};

const MobileThreeGridComponent = (props) => {
    const { title, products, redirectLink } = props;
    const [productLoading, setProductionLoading] = useState(false);

    useEffect(() => {
        setProductionLoading(true);
        if (products?.length > 0) {
            setProductionLoading(false);
        }
    }, [products?.length]);


    if (productLoading) {
        return (
            <Box sx={{
                minHeight: "30vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            component={"div"}
            sx={{
                my: 3,
                px: 1,
                pb: 1.5,
                backgroundColor: "white.main",
            }}
        >
            {title && (
                <Stack sx={{
                    mb: 1,
                }}>
                    <MobileSectionTitle
                        sectionTitle={title}
                        buttonText={null}
                        redirectLink={redirectLink}
                    />
                </Stack>
            )}

            <Box
                component={"div"}
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "repeat(3, 1fr)",
                        sm: "repeat(4, 1fr)",
                    },
                    rowGap: 2,
                    columnGap: 1,
                }}
            >
                {products?.map((item, idx) => {
                    return (
                        <MaxDiscountCard
                            key={`gift-card-99-${idx}`}
                            image={item?.most_selling}
                            altText={item?.title}
                            discount={item?.discount}
                            data={item}
                        />
                    )
                })}
            </Box>
        </Box>
    )
}

export default MobileThreeGridComponent;


function hexToRgba(hex, alpha = 1) {
    // Remove leading '#' if present
    hex = hex.replace(/^#/, '');

    // Convert shorthand hex (#abc) to full form (#aabbcc)
    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    // Parse r, g, b values
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    return `${r}, ${g}, ${b}, ${alpha}`;
}